import { useSearchParams } from 'react-router-dom';
import { useUnsubscribe } from 'hooks/api/invitation';
import { Parameters } from 'constants/queryParameters';
import { UnsubscribeNegative, UnsubscribePositive } from 'assets/icons';
import Button from 'components/Button';

import styles from './Unsubscribe.module.css';
import messages from './Unsubscribe.messages';

const Unsubscribe = (): JSX.Element => {
  const accessKey = useSearchParams()[0].get(Parameters.accessKey);

  const {
    mutate: unsubscribe,
    isLoading,
    isSuccess,
    isError: isMutateError,
  } = useUnsubscribe();

  const isError = !accessKey || isMutateError;

  if (isError) {
    return (
      <>
        <div className={styles.icon}>
          <UnsubscribeNegative />
        </div>

        <h1 className={styles.title}>{messages.errorTitle}</h1>
        <p className={styles.text}>{messages.errorDescription}</p>
      </>
    );
  }

  if (isSuccess) {
    return (
      <>
        <div className={styles.icon}>
          <UnsubscribeNegative />
        </div>

        <h1 className={styles.title}>{messages.unsubscribedTitle}</h1>
        <p className={styles.text}>{messages.unsubscribedText}</p>
      </>
    );
  }

  return (
    <>
      <div className={styles.icon}>
        <UnsubscribePositive />
      </div>

      <h1 className={styles.title}>{messages.unsubscribingTitle}</h1>
      <p className={styles.text}>{messages.unsubscribingText}</p>

      <div className={styles.button}>
        <Button
          isLoading={isLoading}
          onClick={() => {
            unsubscribe();
          }}
        >
          {messages.unsubscribeButton}
        </Button>
      </div>
    </>
  );
};

export default Unsubscribe;
